import { type Static, Type } from "@sinclair/typebox"
import {
  type ChallengeRecordList,
  type ChallengeStatusSchema,
  ManagedChallengeRecordSchema,
} from "../schemas"

export type ChallengeStatus = Static<typeof ChallengeStatusSchema>
export type ChallengeRecord = Static<typeof ManagedChallengeRecordSchema>

export const ChallengeStoreSchema = Type.Record(
  Type.String(),
  ManagedChallengeRecordSchema,
)

export type ChallengeStore = Static<typeof ChallengeStoreSchema>

export const CHALLENGE_STORE_KEY = "craft-force.challenges"
export const CHALLENGE_STORE_VERSION = 1
export const EMPTY_CHALLENGE_STORE: ChallengeStore = {}

export function createChallengeId(): string {
  return `chal_${crypto.randomUUID().replace(/-/gu, "")}`
}

export function challengeStoreToList(
  store: ChallengeStore,
): ChallengeRecordList {
  return Object.values(store)
}

export function challengeListToStore(
  records: readonly ChallengeRecord[],
): ChallengeStore {
  return Object.fromEntries(
    records.map((record) => [record.challengeId, record]),
  )
}
